import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
// import linkIcon from 'assets/images/Attachment.svg';
import { DocumentsCard } from './components/DocumentsCard';
import { VStack, HStack } from 'components';
import styled from 'styled-components';
import { Attachments } from 'types';
import { useKeycloak } from 'all-in-one-react-keycloak';
import { usePaymentProof } from 'all-in-one-shared-api';
import { Typography, Button, Alert } from 'antd';
import { Form } from 'antd';
import { FormProvider, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import { SuccessPage } from './SuccessPage';
import uploudlistIcon from 'assets/images/support/uploudlist.svg';
import { isLocaleEnglish } from 'utils/languageUtils';
import GreetingSection from '../../components/navbar/GreetingSection';
import { usePaymentSuccessQuery } from '../../hooks';

// import { useMediaQuery } from 'react-responsive';
export const TitleContainer = styled(HStack)`
  justify-content: flex-start;
`;
export const LifePaymentUploadScreen = () => {
  // const isLargeScreen = useMediaQuery({ minWidth: 768 });
  const { i18n } = useTranslation();
  const isEnglish = isLocaleEnglish(i18n.language);
  const { Text } = Typography;
  const { keycloak } = useKeycloak();
  const [attachments, setAttachments] = useState<Attachments>();
  const [paymentReference, setEnquiryReference] = useState<string>('');
  const [isDone, setIsDone] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const methods = useForm();
  interface requestProps {
    paymentType: string;
    companyCode: string;
    premiumDueDate: string;
    policyNumber: string;
    uploadFlag: boolean;
  }
  const location = useLocation() as {
    state: {
      policyNumber: string;
      paymentType: string;
      requestPart: requestProps;
      message: string;
    };
  };
  const { policyNumber, requestPart, paymentType, message } = location.state;
  const navigate = useNavigate();
  const successState = usePaymentSuccessQuery();
  const [randoms, setRandoms] = useState(Math.random());

  const { t } = useTranslation();
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const [errMessage, setErrMessage] = useState<string>('');
  const [errMessage2 /*setErrMessage2*/] = useState<string>('');
  // const {
  //   // control,
  //   // getValues,
  //   handleSubmit,
  //   // setValue,
  //   // formState: { errors },
  // } = useForm<FormProps>({
  //   defaultValues: {},
  // });
  const [documentInvalid, setDocumentInvalid] = useState(false);
  const generalData = {
    paymentType: paymentType,
    companyCode: requestPart.companyCode,
    premiumDueDate: requestPart.premiumDueDate,
    policyNumber: requestPart.policyNumber,
    files: attachments?.fileList?.map((a) => a.originFileObj) || [],
    uploadFlag: false,
  };

  const {
    data: paymentProofData,
    error: paymentProofError,
    shouldFetch: shouldProofFetch,
  } = usePaymentProof('payment-proof' + randoms, keycloak.token ?? '', generalData, {
    shouldRetryOnError: false,
  });

  type EnquiryFormInput = {
    name: string;
    email: string;
    phone: string;
    enquiryType: string;
    feedback: string;
    attachments: Attachments;
  };
  const [form] = Form.useForm<EnquiryFormInput>();

  useEffect(() => {
    if (paymentProofData?.success) {
      setErrMessage('');
      shouldProofFetch(false);
      if (!paymentType) {
        navigate(
          { pathname: '/LIPayment/CreditCardSuccess' },
          {
            state: successState,
          },
        );
      }
      const paymentReference: string = paymentProofData.message;
      setEnquiryReference(paymentReference);
    }
    // eslint-disable-next-line
  }, [paymentProofData, shouldProofFetch]);
  useEffect(() => {
    if (paymentProofError) {
      shouldProofFetch(false);
      setIsSubmitting(false);
      setErrMessage(paymentProofError.message);
      // console.log('enquirySubmissionError', enquirySubmissionError);
    }
  }, [paymentProofError, shouldProofFetch]);
  useEffect(() => {
    if (!snackbarMessage) return;
    shouldProofFetch(false);
    setIsLoading(false);
  }, [snackbarMessage, shouldProofFetch, isLoading]);
  useEffect(() => {
    if (paymentProofData) {
      setEnquiryReference(paymentProofData.message);
    }
    if (paymentProofError) {
      setSnackbarMessage(paymentProofError.message);
    }
  }, [paymentProofData, paymentProofError]);

  // useEffect(() => {
  //   if (!snackbarMessage) return;
  //   shouldProofFetch(false);
  //   setIsLoading(false);
  // }, [snackbarMessage, shouldProofFetch, isLoading]);

  useEffect(() => {
    if (!paymentReference) return;
    shouldProofFetch(false);
    setIsDone(true);
    // setIsLoading(false);
  }, [paymentReference, setIsDone, shouldProofFetch]);

  const onSubmit = (values: EnquiryFormInput) => {
    setSnackbarMessage('');
    setEnquiryReference('');
    setAttachments(values.attachments);
  };
  useEffect(() => {
    if (attachments && attachments.fileList.length > 0) {
      setRandoms(Math.random());
      shouldProofFetch(true);
      setIsLoading(true);
    }
  }, [attachments, shouldProofFetch]);
  if (isDone) {
    return <SuccessPage paymentReference={policyNumber} paymentType={paymentType} />;
  }

  return (
    <>
      <GreetingSection pageName={t('upload.paymentTitle')} showicon={true} />
      <div
        style={{
          backgroundColor: 'white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '20px',
          marginTop: '40px',
          maxWidth: '100%',
        }}
      >
        <div
          style={{
            backgroundColor: 'white',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '672px',
            maxWidth: '100%',
          }}
        >
          <div style={{ width: '640px', maxWidth: '100%', background: 'white' }}>
            <VStack
              style={{
                paddingRight: 16,
                marginBottom: '20px',
                backgroundColor: 'transparent',
                borderBottom: '1px solid #ccc',
              }}
            >
              <Text style={{ display: 'block', width: '100%', fontFamily: 'Roboto400', fontSize: '17px' }}>
                {t('forgetPassword.policyNumberLabel')}
              </Text>
              <Text style={{ display: 'block', width: '100%', fontFamily: 'Roboto400', fontSize: '20px' }}>
                {policyNumber}
              </Text>
              {/* {iconProps && <SvgIcon style={{ height: 22) }} {...iconProps} />} */}
            </VStack>
            {message && (
              <Text
                style={{
                  display: 'block',
                  width: '100%',
                  fontFamily: 'Roboto400',
                  fontSize: '17px',
                  whiteSpace: 'pre-line',
                }}
              >
                {t(message)}
              </Text>
            )}
            <Text
              style={{ display: 'block', width: '100%', fontFamily: 'Roboto400', fontSize: '17px', marginTop: '20px' }}
            >
              {t('upload.paymentTitle')}
            </Text>
            <div style={{ display: 'flex', flexDirection: 'row', paddingTop: 10 }}>
              <img src={uploudlistIcon} style={{ margin: '0  10px 5px 0', width: '24px', height: '24px' }} />

              <Text style={{ paddingBottom: 10, color: '#B0B2B3' }}>{t('upload.AttachmentsLabel')}</Text>
            </div>
            <Text style={{ color: '#B0B2B3', whiteSpace: 'pre-line' }}>{t('upload.paymentDescription')}</Text>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                maxWidth: '100%',
                background: 'white',
              }}
            >
              <FormProvider {...methods}>
                <Form
                  requiredMark={false}
                  form={form}
                  layout="vertical"
                  onFinish={onSubmit}
                  style={{ maxWidth: '100%' }}
                >
                  <DocumentsCard setInvalid={setDocumentInvalid} />
                </Form>
              </FormProvider>
            </div>
            {errMessage && (
              <Alert
                className="custom-alert"
                message={errMessage}
                type="error"
                style={{
                  marginTop: 16,
                  border: 'none',
                }}
              />
            )}
            {errMessage2 && (
              <Alert
                className="custom-alert"
                message={errMessage2}
                type="error"
                style={{
                  marginTop: 16,
                  border: 'none',
                }}
              />
            )}
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <Button
                loading={isLoading}
                block
                type="primary"
                size="large"
                onClick={() => form.submit()}
                htmlType="submit"
                style={{
                  fontFamily: 'Roboto500',
                  fontSize: '20px',
                  height: '56px',
                  width: '428px',
                  maxWidth: '100%',
                }}
                disabled={documentInvalid || isSubmitting}
              >
                {isEnglish ? 'Submit' : '提交'}
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
